import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { Loading, PublicLayout } from '@catalyze/ui';
import { useChangePasswordMutation } from 'api/password/changePassword';
import { useValidateEmailTokenMutation } from 'api/session/validateEmailToken';
import type { ICreatePasswordForm } from 'features/CreatePassword/components/ChangePasswordForm';
import { ChangePasswordForm } from 'features/CreatePassword/components/ChangePasswordForm';
import {
    EmailTokenErrorMsg,
    ErrorInfoMsg,
    SuccessInfoMsg,
} from 'features/CreatePassword/components/StatusMessages';

type TCreatePasswordRouteParams = {
    emailToken: string;
};

export const ChangePassword = () => {
    const {
        isError: isEmailValidatonError,
        mutate: validateEmailToken,
        isLoading,
    } = useValidateEmailTokenMutation({});

    const { emailToken } = useParams<TCreatePasswordRouteParams>();

    useEffect(() => {
        if (emailToken) {
            validateEmailToken({ token: emailToken });
        }
    }, [emailToken, validateEmailToken]);

    const { isSuccess, isIdle, isError, mutate } = useChangePasswordMutation(
        {}
    );

    const onFormSubmit = (data: ICreatePasswordForm) => {
        mutate({
            emailToken: emailToken ?? '',
            password: data.password,
        });
    };

    return (
        <PublicLayout>
            {isLoading && <Loading />}
            {!emailToken || isEmailValidatonError ? (
                <EmailTokenErrorMsg />
            ) : (
                <>
                    {isSuccess && <SuccessInfoMsg />}
                    {isError && <ErrorInfoMsg />}
                    {isIdle && !isLoading && (
                        <ChangePasswordForm onSubmit={onFormSubmit} />
                    )}
                </>
            )}
        </PublicLayout>
    );
};
